/* Main Menu */
var $ = jQuery.noConflict();

$(function () {
	$(document).ready(function () {
		////////////////////////////////////////////////
		// START - slick slider example
		var slider = $('.slider-items');
		var slideStatus = $('.slider-page-info');

		if (slider.length > 0) {
			// set slides to same height
			slider.on('setPosition', function () {
				$(this).find('.slick-slide').height('auto');
				var slickTrack = $(this).find('.slick-track');
				var slickTrackHeight = $(slickTrack).height();
				$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
			});

			// add numbers for 1 of 5 or however many slider there are
			slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
				//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
				var i = (currentSlide ? currentSlide : 0) + 1;
				slideStatus.text(i + '/' + slick.slideCount);
			});

			// initiate slider for home page
			slider.slick({
				autoplay: false,
				dots: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: $('#slider-prev'),
				nextArrow: $('#slider-next'),
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1
						}
					},
				]
			});
		}
		// END - slick slider example
		///////////////////////////////////////////////

		////////////////////////////////////////////////
		// START - slick slider with nav example
		var sliderWithNav = $('.slider-with-nav');
		var sliderNav = $('.slider-nav');

		if (sliderWithNav.length > 0) {
			sliderWithNav.slick({
				autoplay: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				asNavFor: '.slider-nav',
				responsive: [
					{
						breakpoint: 767,
						settings: {
							fade: false,
							autoplay: false
						}
					},
				]
			});
			sliderNav.slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				asNavFor: '.slider-with-nav',
				dots: false,
				focusOnSelect: true,
				vertical: true,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							// slidesToShow: 3,
							// slidesToScroll: 1,
							vertical: false
						}
					},
				]
			});
		}
		// END - slick slider with nav example
		///////////////////////////////////////////////

        // Mobile menu slider back navigation.
        $(document).on('click', '#main-menu [data-menu-back]', function(){        
            $(this).parent().parent().find('[data-bs-toggle="dropdown"]').removeClass('show');
            $(this).parent().removeClass('show');  
        })

        
        // Reposition popout items if overflowing body
        $(document).on('click', '.dropdown-toggle, .sub-dropdown-toggle', function(){
            if($(window).width() > 991){
                $('ul.dropdown-menu').removeClass('menu-item-overflow');
                // Start IntersectionObserver
                const onIntersectionChange = entries => {
                    entries.forEach(entry => {                    
                        const intersecting = entry.isIntersecting
                        if(intersecting){
                            //entry.target.classList.remove('menu-item-overflow')
                        } else {
                            entry.target.classList.add('menu-item-overflow')
                        }
                    })
                }
                    
                // IntersectionObserver options
                const options = {
                    root: document.body,
                    threshold: 1,
                }
                    
                const io = new IntersectionObserver(onIntersectionChange, options);
                const lis = document.getElementsByClassName('dropdown-menu');
                // Loop dropdown-menu, checking each with IntersectionObserver
                Array.from(lis).forEach(li => io.observe(li));
            }
        }); 
    });

});

"use strict";

////////////////////////////////////////////////
// START -  add class header--white
document.addEventListener('scroll', function () {
	var headerElement = document.querySelector('.header');

	if (window.scrollY > 40) {
		headerElement.classList.add('header--white');
	} else {
		headerElement.classList.remove('header--white');
	}
});
// END - add class header--white
///////////////////////////////////////////////

////////////////////////////////////////////////
// START -  add remove class header--dark

document.addEventListener('DOMContentLoaded', function () {
	// Get the header element
	var headerElement = document.querySelector('.header');

	// Get the first section after main
	var mainElement = document.querySelector('main');
	var firstSection = mainElement ? mainElement.querySelector('section') : null;

	// If the first section has the class 'hero--bg'
	if (firstSection && firstSection.classList.contains('hero--bg')) {
		// Add the 'header--dark' class to the header element
		headerElement.classList.add('header--dark');
	} else {
		// Else, remove the 'header--dark' class
		headerElement.classList.remove('header--dark');
	}
});

// END - add class header--dark
///////////////////////////////////////////////

////////////////////////////////////////////////
// START -  mobile nav toggle JS
var navbarToggler = document.querySelector('.navbar-toggler');
var navbarBg = document.querySelector('.navbar-bg');
var navBar = document.querySelector('.navbar');
var ariaExpanded = navbarToggler.getAttribute('aria-expanded');
var navbarWrapper = document.querySelector('.wrapper-navbar');

navbarToggler.addEventListener('click', function () {

	navBar.classList.toggle('is-active');
	navbarWrapper.classList.toggle('is-active');

	if (ariaExpanded == 'true') {
		ariaExpanded = 'false'
	} else {
		ariaExpanded = 'true'
	}
	navbarToggler.setAttribute('aria-expanded', ariaExpanded);
});
// END - mobile nav toggle JS
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - remove load class from body
$(window).on('load', function () {
	// When the page has loaded
	$('body').removeClass('page-loading');
});
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
	if (e.keyCode === 9) {
		document.body.classList.add('user-is-tabbing');
		window.removeEventListener('keydown', handleFirstTab);
		window.addEventListener('mousedown', handleMouseDownOnce);
	}
}

function handleMouseDownOnce() {
	document.body.classList.remove('user-is-tabbing');
	window.removeEventListener('mousedown', handleMouseDownOnce);
	window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////


////////////////////////////////////////////////
// START - initialise Clipboard JS on click of share button and copy page URL
var clipboard = new ClipboardJS('#copyButton');
var tooltip = document.querySelector(".tooltip");

clipboard.on('success', function (e) {
	tooltip.classList.remove("d-none");
	tooltip.classList.add("d-block");
	tooltip.innerHTML = 'URL copied: ' + e.text;

	setTimeout(function () {
		tooltip.classList.remove("d-block");
		tooltip.classList.add("d-none");
	}, 2000);
});

clipboard.on('error', function (e) {
	tooltip.classList.remove("d-none");
	tooltip.classList.add("d-block");
	tooltip.innerHTML = 'Could not copy page URL';

	setTimeout(function () {
		tooltip.classList.remove("d-block");
		tooltip.classList.add("d-none");
	}, 2000);
});

// END - initialise Clipboard JS on click of share button and copy page URL
////////////////////////////////////////////////


////////////////////////////////////////////////
// START - filters for archive page.
$(document).ready(function () {
	// Get the URL parameters
	const urlParams = new URLSearchParams(window.location.search);

	// Get the 'topic' and 'date' parameters
	const selectedTopic = urlParams.get('topic') || 'all';
	const selectedDate = urlParams.get('order') || 'bydate';

	// Set the selected options in the dropdowns
	$('#topic-filter').val(selectedTopic);
	$('#arch-date-filter').val(selectedDate);

	// Add an event listener for topic changes
	$('#topic-filter').on('change', function () {
		var topic = $('#topic-filter').val();
		var archiveUrl = window.location.href;

		if (topic !== 'all') {
			archiveUrl = updateQueryStringParameter(archiveUrl, 'topic', topic);
		} else {
			archiveUrl = removeQueryStringParameter(archiveUrl, 'topic');
		}

		// Redirect to the updated URL
		window.location.href = archiveUrl;
	});

	// Add an event listener for date changes
	$('#arch-date-filter').on('change', function () {
		var dateVal = $('#arch-date-filter').val();
		var archiveUrl = window.location.href;

		if (dateVal === 'DESC') {
			archiveUrl = updateQueryStringParameter(archiveUrl, 'order', 'DESC');
		} else if (dateVal === 'ASC') {
			archiveUrl = updateQueryStringParameter(archiveUrl, 'order', 'ASC');
		} else {
			archiveUrl = removeQueryStringParameter(archiveUrl, 'order');
		}

		// Redirect to the updated URL
		window.location.href = archiveUrl;
	});

	// Function to update or add a query parameter in the URL
	function updateQueryStringParameter(uri, key, value) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		} else {
			return uri + separator + key + "=" + value;
		}
	}

	// Function to remove a query parameter from the URL
	function removeQueryStringParameter(uri, key) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		if (uri.match(re)) {
			return uri.replace(re, '$1').replace(/(&)$/, '');
		} else {
			return uri;
		}
	}
});


// 	// When the topic filter or date filter changes
// 	$('#topic-filter, #arch-date-filter').change(function () {
// 		var selectedTopic = $('#topic-filter').val();
// 		var selectedDate = $('#arch-date-filter').val();
// 		updateURLParameters(selectedTopic, selectedDate);
// 		window.location.reload();
// 	});

// 	// Function to update the URL parameters
// 	function updateURLParameters(topic, date) {
// 		var newURL = window.location.href.split('?')[0] + '?';

// 		if (topic) {
// 			newURL += 'topic=' + topic;
// 		}

// 		if (date) {
// 			newURL += (topic ? '&' : '') + 'date=' + date;
// 		}

// 		window.history.pushState({}, '', newURL);
// 	}

// 	// Function to read and apply URL parameters
// 	function applyURLParameters() {
// 		var urlParams = new URLSearchParams(window.location.search);
// 		var topicParam = urlParams.get('topic');
// 		var dateParam = urlParams.get('date');

// 		// Apply the URL parameter to the topic filter
// 		$('#topic-filter').val(topicParam);

// 		// Clear the topic parameter from the URL if no topic is selected
// 		if (!topicParam) {
// 			var newURL = window.location.href.split('?')[0] + '?';
// 			if (dateParam) {
// 				newURL += 'date=' + dateParam;
// 			}
// 			window.history.pushState({}, '', newURL);
// 		}
// 	}

// 	// Apply filters based on the URL parameters when the page loads
// 	applyURLParameters();
// });



// END - filters for archive page
////////////////////////////////////////////////

// const observer = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       console.log(entry.target.classList);
//         const intersecting = entry.isIntersecting
//       entry.target.style.backgroundColor = intersecting ? "blue" : "orange"
//     })
//   }, { threshold: 1 })
  
//   observer.observe(document.getElementById("menu-item-1528"))
